import React from "react";
import PropTypes from "prop-types";
import { Formik, Form } from "formik";
import { MdError } from "react-icons/md";
import Grid from "@mui/material/Grid";

import { useStyles } from "../../../layout/Styles";
import ItemRow from "../../../layout/ItemRow";

const propTypes = {
  form: PropTypes.shape({
    initialValue: PropTypes.object.isRequired,
    validation: PropTypes.object,
    submitHandler: PropTypes.function,
    text: PropTypes.string,
    placeholder: PropTypes.string,
    btnText: PropTypes.string.isRequired,
    btnVariant: PropTypes.object,
    btnIcon: PropTypes.object,
  }),
};

FormInputWrapper.prototype = propTypes;

export default function FormInputWrapper(props) {
  const form = props.form;
  const [submitting, setSubmitting] = React.useState(false);
  const styles = useStyles();
  return (
    <Formik
      initialValues={{ value: "" }}
      validationSchema={form.validation}
      validateOnChange={true}
      onSubmit={(values) => {
        setSubmitting(true);
        form.submitHandler(values.value);
        setTimeout(() => {
          submitting && setSubmitting(false);
        }, 1000);
      }}
    >
      {({ values, setFieldValue, errors, touched }) => {
        return (
          <Form>
            <Grid
              container
              direction="row"
              justifyContent="space-evenly"
              className={styles.messageForm}
            >
              <ItemRow
                children={
                  <>
                    {form.text && <div className={styles.label}>{form.text}</div>}
                    <textarea
                      placeholder={form.placeholder && form.placeholder}
                      onChange={(e) => {
                        setFieldValue("value", e.target.value);
                      }}
                    />
                    {errors.value && touched && (
                      <div className={styles.error}>
                        <MdError /> {errors.value}
                      </div>
                    )}
                  </>
                }
              />

              <ItemRow
                children={
                  <div
                    className={
                      !errors.value
                        ? form.btnVariant
                        : submitting
                        ? styles.disabledBtn
                        : styles.disabledBtn
                    }
                  >
                    <button type="submit" disabled={errors.value || submitting ? true : false}>
                      {form.btnText} {form.btnIcon}
                    </button>
                  </div>
                }
              />
            </Grid>
          </Form>
        );
      }}
    </Formik>
  );
}
